import { render } from "./SearchResult.vue?vue&type=template&id=4402f3a8"
import script from "./SearchResult.vue?vue&type=script&lang=js"
export * from "./SearchResult.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\mli\\JTX\\ichioshiSS\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__